import { InputLabel, MenuItem, Select, FormControl } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DeviceTypeParameterFieldProps } from './TextParameterField';

const SelectParameterField = (props: DeviceTypeParameterFieldProps) => {
  const { t } = useTranslation();

  const sortedOptions = Object.keys(props.parameter.options).sort((a, b) => {
    const textA = props.parameter.options[a].toUpperCase(); // ignorar mayúsculas y minúsculas
    const textB = props.parameter.options[b].toUpperCase(); // ignorar mayúsculas y minúsculas
    if (textA < textB) {
      return -1;
    }
    if (textA > textB) {
      return 1;
    }
    return 0;
  });

  return (
    <FormControl fullWidth>
      <InputLabel id={`${props.parameter.identifier}-label`}>{t(props.parameter.label)}</InputLabel>
      <Select
        fullWidth
        labelId={`${props.parameter.identifier}-label`}
        id={`${props.parameter.identifier}-select`}
        value={props.value.value ? props.value.value.toString() : ''}
        label={t(props.parameter.label)}
        onChange={(event) => {
          props.changeHandler(event.target.value);
        }}
      >
        <MenuItem value={''}>{t('select_a_value')}</MenuItem>
        {sortedOptions.map((name: string, index: number) => {
          return (
            <MenuItem key={`${name}-${index}`} value={name.toString()}>
              {props.parameter.options[name]}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
export default SelectParameterField;
